export default "__VITE_ASSET__DIZDyQPi__"